import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.scss'],
})
export class DynamicTableComponent implements OnInit {
  @Input() tableConfig: any[] = [];
  @Input() jsonData: any[] = [];
  @Input() deleteAction: boolean = false;
  @Input() editAction: boolean = false;

  @Input() disabledActions: boolean = false;

  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.cdr.detectChanges();
  }

  handleDelete(index: number, item: any) {
    this.onDelete.emit({ index, item });
  }

  handleEdit(index: number, item: any) {
    this.onEdit.emit({ index, item });
  }
}
